import { CardMedia as MuiCardMedia } from '@mui/material';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { jsx as _jsx } from "react/jsx-runtime";
export const CardMedia = props => {
  const {
    sx,
    height,
    width,
    objectFit = 'cover',
    maxWidth,
    maxHeight,
    ...rest
  } = props;
  const defaultStyle = {
    height,
    width,
    objectFit,
    maxWidth,
    maxHeight
  };
  const style = mergeSxStyle(defaultStyle, sx);
  return /*#__PURE__*/_jsx(MuiCardMedia, {
    sx: style,
    ...rest
  });
};